import { ProcessCRM as PCrm } from "./pis";
import ENV                    from "react-web-config";

console.log("Environment", ENV?.APP_ENV);

export const ProcessCRM = new PCrm({ mode: ENV?.APP_ENV });
